var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('breadcrumb',{attrs:{"list":_vm.breadcrumbList}}),_c('tl-tabs',{staticClass:"margintop-40",attrs:{"tabs":_vm.tabs}},[_c('tl-tab',[_c('payments-taxes')],1),_c('tl-tab',[_c('employee-list')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }